var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimsAtom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 424,
    viewBox: "0 0 430 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.989 343.882C318.052 328.257 305.901 256.545 263.85 183.707C221.798 110.869 165.77 64.4883 138.707 80.1126C111.644 95.7369 123.795 167.45 165.847 240.287C207.898 313.125 263.927 359.506 290.989 343.882Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.882 268.528C298.988 268.527 367.168 243.193 367.168 211.944C367.167 180.695 298.986 155.363 214.881 155.364C130.776 155.365 62.5953 180.699 62.5957 211.948C62.5961 243.197 130.777 268.529 214.882 268.528Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.741 343.874C165.804 359.499 221.834 313.118 263.887 240.279C305.941 167.44 318.093 95.726 291.03 80.101C263.967 64.4761 207.936 110.857 165.883 183.696C123.829 256.535 111.677 328.249 138.741 343.874Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.543 229.896C214.434 235.607 227.082 232.218 232.793 222.327C238.504 212.436 235.115 199.788 225.223 194.077C215.332 188.366 202.684 191.755 196.973 201.647C191.263 211.538 194.652 224.186 204.543 229.896Z",
    fill: "#FFDB80",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimsAtom2);
export default __webpack_public_path__ + "static/media/lims-atom-2.4cc51ea4d307462a88e861bdd9e60bc5.svg";
export { ForwardRef as ReactComponent };